import React from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import Button from "./Button";
import { ReactComponent as CloseIcon } from "../img/icons/close.svg";

ReactModal.setAppElement("#root");

const Modal = (props) => {
  return (
    <ModalStyle {...props}>
      <ModalContentStyle>
        <Button icon onClick={props.hideModal}>
          <CloseIcon />
        </Button>
        <div>{props.children}</div>
      </ModalContentStyle>
    </ModalStyle>
  );
};
export default Modal;

const ModalStyle = styled(ReactModal)`
  position: fixed;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.07);
  background-color: ${({ theme }) => theme.color.background} !important;
  border: 1px solid ${({ theme }) => theme.color.border};
  width: clamp(575px, 500px, 100%);
  max-height: 85vh;
  padding: 0 100px;
  overflow: hidden;
  padding-bottom: 0px;
  display: flex;
  :focus {
    outline: none;
  }

  @media (max-width: 576px) {
    width: 100%;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    transform: none !important;
    border-radius: 5px 5px 0 0;
    padding: 25px 1.5rem 0;
  }
`;

const ModalContentStyle = styled.div`
  position: relative;
  width: 100%;
  color: ${({ theme }) => theme.color.darkerText};
  > button:first-child {
    position: absolute;
    right: -75px;
    top: 15px;
    padding: 20px;
    svg {
      max-height: 10px;
      min-height: 10px;
      max-width: 10px;
      min-width: 10px;
      path {
        fill: ${({ theme }) => theme.color.primaryText};
      }
    }
    @media (max-width: 576px) {
      position: fixed;
      right: 10px;
      top: 10px;
      background-color: ${({ theme }) => theme.color.secondaryBg};
    }
  }
  > div {
    height: 100%;
    overflow: auto;
    padding: 3px;
    padding-bottom: 60px;
    padding-top: 60px;
    ${({ theme }) => theme.hideScroller()}
    @media (max-width: 576px) {
      padding-top: 0px;
      padding-bottom: 20px;
    }
  }
`;
